import { render, staticRenderFns } from "./CesShopGoodsModal.vue?vue&type=template&id=c387ec32"
import script from "./CesShopGoodsModal.vue?vue&type=script&lang=js"
export * from "./CesShopGoodsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports